<router-outlet></router-outlet>
<app-global-loading></app-global-loading>
<app-toast></app-toast>
<app-pwa-install-banner></app-pwa-install-banner>
<app-debug-console></app-debug-console>